export const GOOGLE_MAPS_API_KEY = "AIzaSyCA3dlEYPFDDwAsOE1Q3gioozw1j-zik2s"
export const BARROCO_LAT_LNG = { lat: 6.557595841388915, lng: -75.82759454640023 }
export const BARROCO_MAP_ID = { light: "cb9b87767f3930ef", dark: "29902c021ef70de" }
